import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ROUTES, CURRENT_PAGE, PER_PAGE} from '../constants/common'
import instance from '../services/baseService';

const generateNotificationUrl = (notification) => {
    console.log(notification);
    let baseUrl = `/`; // Adjust as per your app's base route

    switch (notification.module) {
        case "GSTR1":
            baseUrl += `gstr-1/${notification.client_id}`;
            break;
        case "GSTR3B":
                baseUrl += `gstr3b/${notification.client_id}`;
                break;
        case "REFUND":
            baseUrl += `refunds/${notification.client_id}`;
            break;
        case "GENERAL":
            baseUrl += `clients/tax-forms/${notification.client_id}`;
            
            break;
        default:
            baseUrl += ''; // Fallback for other routes
    }

    return baseUrl;
};
  
export const getNotifications = createAsyncThunk('notification/getNotifications', async ({page, latest_notification_id}, thunkAPI) => {
    try {
        const data = {
            page: CURRENT_PAGE,
            perpage: PER_PAGE
        }
        if (page ) data.page  = page;
        //if (latest_notification_id ) data.latest_id  = latest_notification_id;
        const response = await instance.post(ROUTES.LIST_NOTIFICATIONS, data);
        return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response ? error?.response?.data?.message : 'Notification Fetching failed')
    }
})

export const fetchNewNotifications = createAsyncThunk('notification/fetchNewNotifications', async ({page, latest_notification_id}, thunkAPI) => {
    try {
        const data = {
            page: CURRENT_PAGE,
            perpage: PER_PAGE
        }
        if (page ) data.page  = page;
        if (latest_notification_id ) data.latest_id  = latest_notification_id;
        const response = await instance.post(ROUTES.LIST_NOTIFICATIONS, data);
        return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response ? error?.response?.data?.message : 'Notification Fetching failed')
    }
})

export const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        isNotificationRoute: false,
        notification: null,
        notificationUrl: null,
        notificationList: [],
        loading: false,
        latestNotificationId: null,
        newNotificationFound: false,
    },
    reducers: {
        setNotification: (state, action) => {
            state.notification = action.payload;
            state.isNotificationRoute = true;
            state.notificationUrl = generateNotificationUrl(action.payload);
        },
        clearNotification: (state) => {
            state.isNotificationRoute = false;
            state.notification = null;
            state.notificationUrl = null;
            state.newNotificationFound = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getNotifications.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getNotifications.fulfilled, (state, action) => {
            console.log(action.payload.data);
            state.loading = false;
            state.notificationList = action.payload.data?.lists;
            if (action.payload.data?.lists.length > 0) {
                state.latestNotificationId = action.payload.data?.lists[0].id;  // store the id of the 0th index
            }
        })
        builder.addCase(getNotifications.rejected, (state, action) => {
            state.loading = false;
            console.log(action);
            state.errorMsg = action.payload?.data ? action.payload?.data : 'Failed to fetch notifications';
        })

        builder.addCase(fetchNewNotifications.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchNewNotifications.fulfilled, (state, action) => {
            console.log(action.payload.data);
            state.loading = false;
            //state.notificationList = action.payload.data?.lists;
            if (action.payload.data?.lists.length > 0) {
                state.newNotificationFound = true;
            }
        })
        builder.addCase(fetchNewNotifications.rejected, (state, action) => {
            state.loading = false;
            console.log(action);
            state.errorMsg = action.payload?.data ? action.payload?.data : 'Failed to fetch notifications';
        })
    }
})

export const { setNotification,clearNotification } = notificationSlice.actions;

export default notificationSlice.reducer;